import {sqftPost} from "./sqftApi";

export default class SqftJsonApi {
  static postCabinetSet(data, options = {}) {
    return sqftPost("/api/AR/Composer", data, options);
  }
}
